module.exports = __webpack_public_path__ + "static/media/2021_2A3A2942.6cfd5545.jpg";